module.exports = __webpack_public_path__ + "media/images/symbols/pin-e3349a351a8c9352669a8c5ef742df55.svg";